export class ProductDetailsModel {
    productId: string;
    dcmCode: string;
    socCode: string;
    quantity: number;
    bundleSkuId: string;
    action: string;
    email: string;
    childDcmCodes: Array<String>;
}
